export default props => {
  if(props.test) {
    return props.children
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/If/index.js